<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useAiStore } from '#layers/ai/stores/ai';
import { useChatStore } from '#layers/ai/stores/chat';
import { ErrorAlert, usePaneStore } from '#layers/ui/public';
import AiChatThreadApproval from './Approval.vue';
import AiChatEmpty from './Empty.vue';
import AiChatHeader from './Header.vue';
import AiChatThreadMessages from './Messages.vue';
import AiChatThreadPrompt from './Prompt/Prompt.vue';

const chatStore = useChatStore();
const paneStore = usePaneStore();
const { enabled, loading } = storeToRefs(useAiStore());

function closeChat() {
	paneStore.togglePanel({ open: false });
}
</script>

<template>
	<DPanel
		:title="$t('ai.chat.title')"
		closable
		@close="closeChat"
	>
		<AiChatEmpty v-if="!loading && !enabled" />

		<div v-else-if="enabled" class="flex min-h-0 grow flex-col px-5">
			<AiChatHeader />
			<AiChatThreadMessages class="pb-12" />
		</div>

		<template v-if="enabled" #footer>
			<div class="p-5 pt-0">
				<ErrorAlert v-if="chatStore.errors.length > 0" :error="chatStore.errors" class="mb-3" />
				<AiChatThreadApproval v-if="chatStore.pendingApproval" />
				<AiChatThreadPrompt v-else />
			</div>
		</template>
	</DPanel>
</template>
